import { IconArrowRight, IconChecks, IconCircleDot, IconSparkles } from '@tabler/icons-react'
import React from 'react'
import { motion } from 'framer-motion';
import { container, item } from './../../pages/homepage/Section1';
import { Link } from 'react-router-dom';

const Section2 = ({s2Contents, datas}) => {
    
  return (
    <div className='s2-fin-reco f-width m-auto'>
        <p className='text-center color-brand text-uppercase fw-bold fs-16px t-a-s'><IconCircleDot stroke={3} /> {datas.subHead} </p>
        <motion.p  variants={container} whileInView="visible" initial="hidden" className='text-center fs-md t-a-s'> {datas.heading} </motion.p>
        <div className='d-flex justify-content-between s2-fin-reco-mb t-a-s'>
            <motion.p  variants={item} whileInView="visible" initial="hidden" transition={{duration: 0.5}}><IconChecks className='color-brand'/> {datas.p1}</motion.p>
            <motion.p  variants={item} whileInView="visible" initial="hidden" transition={{duration: 1}}><IconChecks className='color-brand'/> {datas.p2}</motion.p>
            <motion.p  variants={item} whileInView="visible" initial="hidden" transition={{duration: 1.5}}><IconChecks className='color-brand'/> {datas.p3}</motion.p>
            <motion.p  variants={item} whileInView="visible" initial="hidden" transition={{duration: 2}}><IconChecks className='color-brand'/> {datas.p4}</motion.p>
        </div>
        {s2Contents.map((s2Content, index) => (
            <div className='row s2-row-bg rounded-4' key={index}>
                <div className='col-sm-12 col-lg-6 align-content-around p-15px'>
                    <p className='color-brand'>{s2Content.id}</p>
                    <p className='fs-32 s2-t-m'>{s2Content.title}</p>
                    <p className='s2-t-m'><font className="fw-bold">Problem</font>: {s2Content.Problem}</p>
                    <p className='s2-t-m'><font className="fw-bold">Solution</font>: {s2Content.Solution}</p>
                    <div className='d-flex light-brand-bg rounded'>
                        <IconSparkles className='color-brand' style={{width:'100px'}} />
                        <p className='mb-0'><font className="fw-bold">Benefits</font>: {s2Content.Benefits}</p>
                    </div>
                    <Link to={'https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal&__hstc=181257784.c6a9d1b3be4a6fd2ed9c2295680beb42.1703009108941.1746471743378.1746554024258.302&__hssc=181257784.2.1746554024258&__hsfp=961219941'} rel="noreferrer" target='_blank'><div className='btn brand-bg text-white rounded-pill shadow'> Learn more <IconArrowRight className='btn-arr' /></div></Link>
                </div>
                <div className='col-sm-12 col-lg-6 p-15px align-content-around'>
                    <motion.img variants={item} whileInView="visible" initial="hidden" transition={{duration: 1}} className='img-fluid rounded-4 shadow-lg' src={s2Content.image} alt={s2Content.title} />
                </div>
            </div>
        ))}
    </div>
  )
}

export default Section2